import { render, staticRenderFns } from "./BFCM2025Banner.vue?vue&type=template&id=02352100"
import script from "./BFCM2025Banner.vue?vue&type=script&lang=js"
export * from "./BFCM2025Banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports